// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__z_Qri","content":"styles_content__36ngt","tableWrap":"styles_tableWrap__2s06S"};